var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.75,
    height: 29.838,
    viewBox: "0 0 30.75 29.838",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier",
    transform: "translate(0.113 0.054)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M764.774,146.022v4.434l2.571,1.974v-5.512a.893.893,0,0,0-.894-.894h-1.677Z",
    transform: "translate(-741.286 -145.13)",
    fill: "#ff6339",
    stroke: "#fff",
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M226.2,276.479V260.63l11.562-9.136,11.562,8.71-.129,16.061Z",
    transform: "translate(-222.639 -246.7)",
    fill: "#00ebb4",
    stroke: "#fff",
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M249.326,260.2l-11.562-8.71-1.15.909,10.056,7.827a.953.953,0,0,1,.367.754V273.59a.944.944,0,0,1-.945.945H226.2v1.943l23-.214Z",
    transform: "translate(-222.639 -246.7)",
    fill: "#00c19c",
    stroke: "#fff",
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M799.488,150.528v5.1l.928.674v-5.633Z",
    transform: "translate(-774.715 -149.469)",
    fill: "#f94a21",
    stroke: "#fff",
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M158.55,135.836a1.869,1.869,0,0,1-1.121-.375l-13.462-10.02-10.585,8.251c-.816.629-2.476,2.231-3.1,1.415a1.864,1.864,0,0,1,.341-2.614l13.263-10.2a1.867,1.867,0,0,1,2.26-.011l13.532,10.2a1.865,1.865,0,0,1-1.125,3.355Z",
    transform: "translate(-129.893 -121.906)",
    fill: "#acb6ff",
    stroke: "#fff",
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M530.033,135.086a1.865,1.865,0,0,0-.367-2.612l-13.532-10.2a1.863,1.863,0,0,0-2.035-.136,3.3,3.3,0,0,1,1.127.654c1.7,1.4,12.445,9.624,12.839,9.888a1.142,1.142,0,0,1,.481,1.411c-.275.549-1.038.892-2.281.313.03.114.634.6.689.7l.468.349a1.864,1.864,0,0,0,2.61-.367Z",
    transform: "translate(-499.885 -121.898)",
    fill: "#5367f9",
    stroke: "#fff",
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M412.211,542.139h-5.8a1.777,1.777,0,0,1-1.777-1.777v-5.8a1.777,1.777,0,0,1,1.777-1.777h5.8a1.777,1.777,0,0,1,1.777,1.777v5.8A1.774,1.774,0,0,1,412.211,542.139Z",
    transform: "translate(-394.469 -517.586)",
    fill: "#acb6fb",
    stroke: "#fff",
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M414.825,541.743v-5.8a1.778,1.778,0,0,0-1.347-1.724V541.3a.774.774,0,0,1-.775.775h-7.2a1.779,1.779,0,0,0,1.746,1.449h5.8A1.78,1.78,0,0,0,414.825,541.743Z",
    transform: "translate(-395.307 -518.966)",
    fill: "#5367f9",
    stroke: "#fff",
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M262.413,498.683a.474.474,0,0,1-.474-.474v-.722a.474.474,0,0,1,.947,0v.722A.474.474,0,0,1,262.413,498.683Zm0-2.567a.474.474,0,0,1-.474-.474v-3.828a1.077,1.077,0,0,1,.438-.864l1.406-1.027a.473.473,0,1,1,.559.763l-1.406,1.027a.12.12,0,0,0-.049.1v3.828A.474.474,0,0,1,262.413,496.116Z",
    transform: "translate(-257.054 -476.221)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.01
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.9c4665ec.svg";
export { ForwardRef as ReactComponent };